// Helpers for price inputs that let the user type MAJOR units (rupees, rials)
// while the app keeps the canonical value in the tenant's MINOR unit (paise,
// baisa) — BIGINT minor units are the storage/domain unit.
//
// Regression: the conversion was hardcoded to ÷100/×100, which assumes a
// 2-decimal currency. On 3-decimal currencies (OMR/BHD/KWD, 1000 subunits) every
// typed amount was recorded at one tenth of its intended value. The subunit
// factor now comes from the tenant currency instead — same approach as
// `pages/modifiers/modifier-utils.ts` (issue #285 Part B).
//
// `currency` defaults to 'INR' so INR behaviour is byte-identical.

import { getSubunitMultiplier } from '@bbpos/utils';
import type { CurrencyCode } from '@bbpos/types';

/** Minor units → the major-unit string shown in the input (e.g. 39900 → "399", 39950 → "399.5"). */
export function paiseToRupeeInput(paise: number | undefined | null, currency: CurrencyCode = 'INR'): string {
  if (!paise) return '';
  return String(paise / getSubunitMultiplier(currency));
}

/** Major-unit input string → minor units, or null when blank/invalid (e.g. "399.50" → 39950). */
export function rupeeInputToPaise(rupees: string, currency: CurrencyCode = 'INR'): number | null {
  const t = rupees.trim();
  if (t === '') return null;
  const n = parseFloat(t);
  if (Number.isNaN(n)) return null;
  return Math.round(n * getSubunitMultiplier(currency));
}
